import { Expose } from "class-transformer";
import { BaseModel } from "src/shared/models";

export class UpdateClaimCacheReponse extends BaseModel {
    @Expose() claimId!: number;
    @Expose() status!: string;
    @Expose() updatedDate!: string;
    @Expose() iaProcess!: boolean;
}
